import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { EChartsOption } from "echarts";
import { LowerBound } from "src/app/core/services/lowerBound.service";
import { ChartService } from "src/app/core/services/waterfallChart.service";



@Component({
  selector: 'app-sales-realization-meritor-chart',
  templateUrl: './sales-realization-meritor-chart.component.html',
  styleUrls: ['./sales-realization-meritor-chart.component.scss']
})
export class SalesRealizationMeritorChartComponent implements OnInit {
  @Input() salesReal: any = {};
  @Input() source: 'nrp' | 'cssna' = 'nrp';
  @Output() chartClick: any = new EventEmitter<any>();

  chartOption: EChartsOption = {};
  data: any[] = [];
  positive: any = [];
  negative: any = [];
  sales_data: any = [];

  min: number = 0;
  max: number = 0;
  start: any = [];
  reduce: number = 0;
  startingPoint: number = 0;
  base: number = 0;
  graphData: any[] = [];
  scaleBreak = true;
  private waterfallRows: any[][] = [];
  constructor(private chart: ChartService, private lowerBound: LowerBound) { }

  ngOnInit(): void {
    let data: any[] = [];
    data[0] = this.salesReal.prior_period_sales;
    data[1] = this.salesReal.attrition_sales;
    data[2] = this.salesReal.prior_period_sales + this.salesReal.attrition_sales;
    data[3] = this.salesReal.price;
    data[4] = this.salesReal.mix_sales;
    data[5] = this.salesReal.volume_sales;
    data[6] = this.salesReal.current_period_sales - this.salesReal.acquisition_sales;
    data[7] = this.salesReal.acquisition_sales;
    data[8] = this.salesReal.current_period_sales;

    this.data = data;
    this.base = 0;
    const waterfallData = [
      [
        'barLabel',
        'barStartValue',
        'barEndValue',
        'referenceDatapoint',
        'index',
      ],
      /*
      [
        '2022 YTD\ndemand',
        this.base,
        this.data[9],
        1,
        0,
      ],*/

      ['Base', this.base, this.data[0], 2, 0],

      ['Attrition', this.data[0], this.data[0] + this.data[1]],

      ['Comparable\n Base', this.base, this.data[2], 2, 0],
      ['Price\nImpact', this.data[2], this.data[2] + this.data[3]],
      [
        'Mix\nImpact',
        this.data[2] + this.data[3],
        this.data[2] + this.data[3] + this.data[4],
      ],
      [
        'Volume\nImpact',
        this.data[2] + this.data[3] + this.data[4],
        this.data[2] + this.data[3] + this.data[4] + this.data[5],
      ],

      [
        'Comparable\nCurrent',
        this.base,
        ( this.salesReal.current_period_sales - this.salesReal.acquisition_sales ),
        2,
        0,
      ],

      [
        'Acquisition',
        this.data[6],
        this.data[6] + this.data[7],
      ],

      ['Current', this.base, this.data[8], 2, 0],
      /* ['2023 YTD\ndemand', this.base, this.data[10], 1, 0], */
    ];
    // if (this.source !== 'cssna') {
    //   waterfallData.splice(1, 0, [
    //     '2022 YTD\ndemand',
    //     this.base,
    //     this.data[9],
    //     1,
    //     0,
    //   ]);
    //   waterfallData.push(['2023 YTD\ndemand', this.base, this.data[10], 1, 0]);
    // }

    this.waterfallRows = waterfallData;
    this.renderChart();
  }

  onScaleBreakToggle(enabled: boolean): void {
    this.scaleBreak = enabled;
    this.renderChart();
  }

  onChartClick(event) {
    this.chartClick.emit(event);
  }

  private renderChart(): void {
    const prepared = this.lowerBound.prepareSalesWaterfall(
      this.waterfallRows,
      this.scaleBreak
    );
    this.startingPoint = prepared.startingPoint;
    this.base = prepared.startingPoint;
    this.chartOption = this.chart.loadWaterFall(
      prepared.data,
      prepared.startingPoint,
      'YOY Sales Realization',
      undefined,
      this.scaleBreak ? 2 : 1
    );
  }
}
